import { Component, Vue } from 'vue-facing-decorator';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Memo, Check, Delete, EditPen, CirclePlusFilled } from '@element-plus/icons-vue';
import Header from '@/components/Header/Header.vue';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
import Navigation from '@/components/Navigation/Navigation.vue';
import NavigationIndex from "@/models/EnumNavigationIndex";
import ApiService from '@/services/ApiService';
import AuthService from '@/services/AuthService';

@Component(
{
    components:
    {
        Header,
        Breadcrumbs,
        Navigation,
		Memo,
		Check,
		EditPen,
		Delete,
		CirclePlusFilled
    },
    enums:
    {
        NavigationIndex
    }
})

export default class Category extends Vue 
{
    private activeName : string = "1";  
    private categoryModelList : CategoryModel[] = [];
    private tableData: object[] = [];
    private loading : boolean = true;
    private formValid : boolean = false;
    private hasPermission: boolean[] = [] as boolean[];
    private toDelete : CategoryModel | undefined;
    private newCategoryModel : CategoryModel = {} as CategoryModel;
	private currentCategory : CategoryModel | undefined;
    private windowWidth : number = window.innerWidth;
    private windowHeight : number = window.innerHeight;
    private rules =
    {
        name:
        [
            {
                required: true,
                message: 'Bitte geben Sie eine Bezeichnung ein.',
                trigger: 'blur'
            }
        ]
    };

    public async mounted()
    {
        // get permissions
        await AuthService.getPermissions();
        this.hasPermission['CATG_SELECT'] = AuthService.hasPermission("CATG_SELECT");
        this.hasPermission['CATG_INSERT'] = AuthService.hasPermission("CATG_INSERT");
        this.hasPermission['CATG_UPDATE'] = AuthService.hasPermission("CATG_UPDATE");
        this.hasPermission['CATG_DELETE'] = AuthService.hasPermission("CATG_DELETE");


        if (this.hasPermission['CATG_SELECT'])
        {
            this.loadList();
        }
        
        window.addEventListener('resize', this.onWindowResize);

        this.loading = false;
    }

    private beforeUnmount()
    {
        window.removeEventListener('resize', this.onWindowResize);
    }

	private onWindowResize(e : any)
    {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }

    private async loadList()
    {
        this.loading = true;
        this.categoryModelList = await ApiService.getAllCategories() as CategoryModel[];
        this.loading = false;
    }

    private async createCategory()
    {
        // send new category model via request to API and await
        let category = await ApiService.createCategory(this.newCategoryModel);

        // check if successful
        if (category)
        {
			ElMessage(
            {
               	message: "Neue Kategorie erfolgreich erstellt.",
               	type: 'success',
            });

            this.activeName = "1";
            this.newCategoryModel = {} as CategoryModel;
            this.formValid = false;
            await this.loadList();
        }
        else
        {
            // or show error message
			ElMessage(
            {
               	message: "Beim Erstellen der neuen Kategorie ist ein Fehler aufgetreten.",
               	type: 'error',
            });
        }
    }

    private async updateCategory(category : CategoryModel)
    {
        let ok : any = await ApiService.updateCategory(category);

        if (ok)
        {
			ElMessage(
            {
               	message: "Änderungen wurden übernommen.",
               	type: 'success',
            });
        }
        else
        {
            // or show error message
			ElMessage(
            {
               	message: "Änderungen konnten nicht gespeichert werden.",
               	type: 'error',
            });

        }
    }

    private async deleteCategory(category : CategoryModel)
    {
        let ok = await ApiService.deleteCategory(category);

        if (ok)
        {
			ElMessage(
            {
               	message: "Kategorie wurde gelöscht.",
               	type: 'success',
            });
            await this.loadList();
        }
        else
        {
            // or show error message
			ElMessage(
            {
               	message: "Kategorie konnte nicht gelöscht werden.",
               	type: 'error',
            });
        }
    }


    private validateForm() : boolean
    {
        if (!this.newCategoryModel.name || this.newCategoryModel.name.length <= 0) return false;

        return true;
    }

    private onInput()
    {
        this.formValid = this.validateForm();
    }

    private onCategorySaveClick(category : CategoryModel)
    {
        this.updateCategory(category);
    }

    private onDeleteConfirm(action : string)
    {
        if (this.toDelete && action == 'confirm')
        {
            this.deleteCategory(this.toDelete);
        }
    }

    private onCategoryDeleteClick(category : CategoryModel)
    {
        this.toDelete = category;

        ElMessageBox.confirm('Soll diese Kategorie wirklich gelöscht werden?', 'Warning', 
        {
            type: 'warning',
            title: '',
            callback: this.onDeleteConfirm,
            confirmButtonText: 'Löschen',
            cancelButtonText: 'Abbrechen'
        });
    }

    private onNewCategoryClick()
    {
        this.createCategory();
    }
}
